import { campaignTypes } from "@campaign/campaign-types.di";
import type { Campaign } from "@campaign/domain/models/campaign.model";
import type { CampaignRepository } from "@campaign/domain/repositories/campaign.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type.ts";
import { inject, injectable } from "inversify";

@injectable()
export class CampaignGetByIdUseCase {
    constructor(
        @inject(campaignTypes.repositories.CampaignRepository)
        private readonly campaignRepository: CampaignRepository,
    ) {}

    async execute(campaignId: string): Promise<Nullable<Campaign>> {
        const campaignResult =
            await this.campaignRepository.fetchById(campaignId);

        if (campaignResult.isErr()) {
            ToastManagerRepository.error(campaignResult.error.message);
        }
        return campaignResult.match(
            (campaign) => campaign,
            () => null,
        );
    }
}
